import Pic1 from './assets/images/pages/1_DSC00770.webp';
import Pic2 from './assets/images/pages/2_DSC01398.webp';
import Pic3 from './assets/images/pages/3_DSC01332.webp';
import Pic4 from './assets/images/pages/4_DSC00054.webp';
import Pic5 from './assets/images/pages/5_DSC00622.webp';
import DesktopRsvpPage from './pages/DesktopRsvpPage';
import FunPage from './pages/FunPage';
import GalleryPage from './pages/GalleryPage';
import MobileRsvpPage from './pages/MobileRsvpPage';
import QaPage from './pages/QaPage';
import SchedulePage from './pages/SchedulePage';

const pages = [
  {
    id: 1,
    titleKey: 'nav.rsvp',
    key: 'rsvp',
    image: Pic1,
    mobileComponent: <MobileRsvpPage />,
    desktopComponent: <DesktopRsvpPage />,
    hideImage: true,
    noPadding: true,
  },
  {
    id: 2,
    titleKey: 'nav.schedule',
    subtitleKey: 'nav.schedule_subtitle',
    key: 'schedule',
    image: Pic2,
    component: <SchedulePage />,
  },
  {
    id: 3,
    titleKey: 'nav.qa',
    key: 'qa',
    image: Pic3,
    component: <QaPage />,
  },
  {
    id: 4,
    titleKey: 'nav.gallery',
    key: 'gallery',
    image: Pic4,
    mobileComponent: <GalleryPage isMobile={true} />,
    desktopComponent: <GalleryPage isMobile={false} />,
  },
  {
    id: 5,
    titleKey: 'nav.fun',
    key: 'fun',
    image: Pic5,
    component: <FunPage />,
  },
];

export default pages;
